import axios from "axios";
import { API_LINKS } from "../constants/links";

export const fetchOrderHistory = (userId) => axios.get(`${API_LINKS.FETCH_ORDER_BY_USER}${userId}`);
